import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { map, takeUntil, startWith, distinctUntilChanged } from 'rxjs/operators';
import { AlgOtpModalComponent } from '../../components/dialogs/alg-otp-modal/alg-otp-modal.component';
import 'moment/locale/it';
import { ModalDialogService } from 'ngx-modal-dialog';
import { UtilsService } from '../../services/utils.service';
import { AlgConditionModalComponent } from '../../components/dialogs/alg-condition-modal/alg-condition-modal.component';

import { AlgConsensoService, REQUEST_STATUS_CANCELED, REQUEST_STATUS_INVALID, REQUEST_STATUS_OK } from '../../services/alg-consenso.service';
import { ApprovalFeedback } from '../../services/alg-consenso.service';
import { LocationStrategy } from '@angular/common';
import { DocsReceptionRequestType, RequestType, RicezioneDocumenti } from '../../models/fisso';

@Component({
  selector: 'app-alg-email-management',
  templateUrl: './alg-email-management.component.html',
  styleUrls: ['./alg-email-management.component.scss'],
})
export class AlgEmailManagementComponent implements OnInit, OnDestroy {
  public isLoading$: Observable<boolean>;
  public isConsentsOk: boolean;
  private phone_number = '';
  public feedbackModalContent = {
    title: 'La tua privacy per noi è importante.',
    description: '',
  };

  public successStepTexts: string[] = ['EMAIL_MANAGEMENT_SUCCESS_STEP_1', 'EMAIL_MANAGEMENT_SUCCESS_STEP_2', 'EMAIL_MANAGEMENT_SUCCESS_STEP_3'];
  public product: any;
  public isLight: boolean;
  public isGas: boolean;
  public isConsents: boolean;
  public idRichiesta: string;
  public requestEmail: string;
  public isOtpChecked: boolean;
  public docsReception: RicezioneDocumenti = {} as RicezioneDocumenti;
  public creationDateOfRequest: any;
  public docsReceptionRequestType: DocsReceptionRequestType;

  private ngUnsubscribe = new Subject<void>();

  // OBSERVABLE TO WATCH REQUEST STATUS
  public isRequestOk$: Observable<boolean>;
  public isErrorGeneric$: Observable<boolean>;
  public isErrorInvalidOffer$: Observable<boolean>;

  public checkboxGeneralCondition = {
    checkboxConsents: false,
  };

  // TEXT PART

  public consentsWithAdditionalProperty: any;
  public isProductGasVulnerable: boolean;
  public isVulnerabilityTypeDisability: boolean;

  private _id: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private consensoService: AlgConsensoService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    public locations: LocationStrategy
  ) {}

  public ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.idRichiesta = params.id;
    });

    this.docsReception.requestId = this.idRichiesta;

    this.consensoService.fetchDocsReception(this.idRichiesta);

    this.isRequestOk$ = this.consensoService.docsReceptionRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_OK),
      startWith(false),
      distinctUntilChanged()
    );

    this.isErrorInvalidOffer$ = this.consensoService.docsReceptionRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_CANCELED),
      startWith(false),
      distinctUntilChanged()
    );

    this.isErrorGeneric$ = this.consensoService.docsReceptionRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_INVALID),
      startWith(false),
      distinctUntilChanged()
    );

    this.consensoService.docsReceptionRequest$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((request) => {
      console.log(request);
      if (!request) return;
      this.docsReception = request;
      this.requestEmail = request.email;
      this.phone_number = request.phone;
      console.log('request emauk', this.docsReception.email);
      this.setDocsReceptionRequestType();
      console.log('request type', this.docsReceptionRequestType);
    });

    // mock
    //this.docsReception = RICEZIONE_DOCUMENTI_LIST[2];
    //this.setDocsReceptionRequestType();

    this.consensoService.isOtpDocsReceptionRequest$.subscribe((value) => {
      this.isConsents = value;
    });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public getTitle() {
    if (!this.docsReceptionRequestType) return '';
    console.log(this.docsReceptionRequestType);
    switch (this.docsReceptionRequestType) {
      case DocsReceptionRequestType.registration:
        return 'TITLE_EMAIL_MANAGEMENT_REGISTRATION';
      case DocsReceptionRequestType.update:
        if (this.docsReception.modifiedAsset && this.docsReception.modifiedAsset.trim()) {
          return 'TITLE_EMAIL_MANAGEMENT_CHANGE_EMAIL_INVOICE';
        } else {
          return 'TITLE_EMAIL_MANAGEMENT_CHANGE_EMAIL';
        }
      case DocsReceptionRequestType.delete:
        return 'TITLE_EMAIL_MANAGEMENT_DELETE_EMAIL';
      default:
        return '';
    }
  }

  private setDocsReceptionRequestType() {
    if (!this.docsReception) return;
    if (this.docsReception.oldPec == null && this.docsReception.pec != null) {
      this.docsReceptionRequestType = DocsReceptionRequestType.registration;
      this.docsReception.requestType = DocsReceptionRequestType.registration;
      this.requestEmail = this.docsReception.pec;
      return;
    }
    if (this.docsReception.oldEmail == null && this.docsReception.email != null) {
      this.docsReceptionRequestType = DocsReceptionRequestType.registration;
      this.docsReception.requestType = DocsReceptionRequestType.registration;
      this.requestEmail = this.docsReception.email;
      return;
    }
    if (this.docsReception.oldPec != null && this.docsReception.pec != null) {
      this.docsReceptionRequestType = DocsReceptionRequestType.update;
      this.docsReception.requestType = DocsReceptionRequestType.update;
      this.requestEmail = this.docsReception.pec;
      return;
    }
    if (this.docsReception.oldEmail != null && this.docsReception.email != null) {
      this.docsReceptionRequestType = DocsReceptionRequestType.update;
      this.docsReception.requestType = DocsReceptionRequestType.update;
      this.requestEmail = this.docsReception.email;
      return;
    }
    if ((this.docsReception.oldPec != null && this.docsReception.pec == null) || (this.docsReception.oldEmail != null && this.docsReception.email == null)) {
      this.docsReceptionRequestType = DocsReceptionRequestType.delete;
      this.docsReception.requestType = DocsReceptionRequestType.delete;
      return;
    }
  }

  public openOTPmodal() {
    this.utils.disableOverflow();
    this.consentsWithAdditionalProperty = {
      requestId: `${this.docsReception.requestId}`,
      requestCode: `${this.docsReception.requestCode}`,
      requestType: `${this.docsReception.requestType}`,
      Alg_OTPCheck__c: false,
      Alg_OTPCheckDate__c: '',
      Alg_OTPPhone__c: '',
    };
    this.isConsentsOk = true;

    this.modalDialogService.openDialog(this.viewContainer, {
      title: 'Un ultimo passo: verifica il tuo numero di cellulare',
      childComponent: AlgOtpModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: 'modal-title modal-title-underline textCenter',
      },
      data: {
        isConsentsOk: this.isConsentsOk,
        consents: this.consentsWithAdditionalProperty,
        phone: this.phone_number,
        linear: false,
        consensoType: 'docs_reception_request',
      },
    });
  }

  private scrollOnInvalidElement(element) {
    document.getElementById(element).scrollIntoView({
      behavior: 'smooth',
      inline: 'nearest',
    });
  }
}

// // Mock
// const RICEZIONE_DOCUMENTI_LIST: RicezioneDocumenti[] = [
//   {
//     requestId: 'REQ12345',
//     requestCode: 'RC001',
//     oldPec: null,
//     oldEmail: 'old.email@example.com',
//     email: 'new.email@example.com',
//     pec: 'new.pec@example.com',
//     address: '123 Main Street, Cityville',
//     modifiedAsset: 'Asset001',
//     customerCode: 'CUST123',
//     fiscalCode: 'FSC1234567890',
//     FirstName: 'Mario',
//     LastName: 'Rossi',
//     requestType: DocsReceptionRequestType.registration,
//   },
//   {
//     requestId: 'REQ12345',
//     requestCode: 'RC001',
//     oldPec: 'old.pec@example.com',
//     oldEmail: 'old.email@example.com',
//     email: 'new.email@example.com',
//     pec: 'new.pec@example.com',
//     address: '123 Main Street, Cityville',
//     modifiedAsset: 'Asset001',
//     customerCode: 'CUST123',
//     fiscalCode: 'FSC1234567890',
//     FirstName: 'Mario',
//     LastName: 'Rossi',
//     requestType: DocsReceptionRequestType.update,
//   },
//   {
//     requestId: 'REQ12345',
//     requestCode: 'RC001',
//     oldPec: 'old.pec@example.com',
//     oldEmail: 'old.email@example.com',
//     email: null,
//     pec: null,
//     address: '123 Main Street, Cityville',
//     modifiedAsset: 'Asset001',
//     customerCode: 'CUST123',
//     fiscalCode: 'FSC1234567890',
//     FirstName: 'Mario',
//     LastName: 'Rossi',
//     requestType: DocsReceptionRequestType.registration,
//   },
// ];



// WEBPACK FOOTER //
// ./src/app/pages/alg-email-management/alg-email-management.component.ts